import {
  DefaultErrorFallback,
  type DefaultErrorFallbackNavigationProps,
} from '@/components/errors/DefaultErrorFallback/DefaultErrorFallback'
import { NewRelic, type NewRelicErrorContext } from '@/monitoring/newrelic'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { type PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useLocation } from 'react-router'

export type DefaultErrorBoundaryProps = PropsWithChildren &
  DefaultErrorFallbackNavigationProps & {
    context: NewRelicErrorContext
    title?: string
  }

export function DefaultErrorBoundary({
  children,
  context,
  title,
  ...navigationProps
}: DefaultErrorBoundaryProps) {
  const location = useLocation()

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          resetKeys={[location.pathname]}
          onReset={reset}
          onError={(error) => NewRelic.noticeError(context, error)}
          FallbackComponent={(p) => (
            <DefaultErrorFallback title={title} {...p} {...navigationProps} />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
